// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"595181cd","208":"056aada1","315":"68b93a04","409":"6ce69627","631":"89c7506c","774":"ee85279c","805":"996b2266"}[chunkId] + ".chunk.js";
};